/**
 * Branding Routes for Schema-Driven Table Component
 * Provides development testing interface for component demonstration
 */

export const brandingRoutes = [
  {
    path: '/branding/tables',
    name: 'tablePlayground',
    component: () => import('@/components/branding/TablePlayground.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Table Component Playground',
      description: 'Schema-driven table component testing interface'
    },
  }
];

/**
 * Add branding routes to existing router instance
 */
export function addBrandingRoutes(router) {
  // Vue Router 3.x compatibility - use addRoutes with array
  router.addRoutes(brandingRoutes);
}